export default "__VITE_ASSET__Cbibp1x5__"